import ClassesBookEdit from './parts/edit';
import { ClassesBookClassLoader } from './provider/ClassesBookClassLoader';
import { useParams } from 'react-router-dom';

const ClassesBookClasses = () => {
  const { sectionId }: { sectionId: string } = useParams();
  return (
    <ClassesBookClassLoader sectionId={sectionId}>
      <ClassesBookEdit />
    </ClassesBookClassLoader>
  );
};

export default ClassesBookClasses;
